module.exports = __webpack_public_path__ + "img/jp.70ae11a3.png";